import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';
import ARGrid from "./Components/ARGrid";

const AnnualRemuneration = () => {

    return (
        <div className="card">
            <ARGrid />
            {/*<MockedGrid />*/}
        </div>
    );
}

export default AnnualRemuneration;